import $ from 'jquery';
import _ from 'underscore';
import smoothScroll from '../../vendor/smooth-scroll';
import responsive from '../../vendor/responsive';
import '../../vendor/jquery.outside-events';

$('.js-toolbox').append('<span class="js-lightbox" data-target="contact-overlay" />');

var container = $('.contact-overlay');
var btn = $('a.trigger', container);
var overlay = $('.overlay', container);
var lightbox = $('.js-lightbox[data-target="contact-overlay"]');
var activeClass = 'js-active';
var closeBtn = $('.js-close', container);

btn.on('click', function (e) {
  e.stopPropagation();
  $(document).trigger('click');
  lightbox.addClass(activeClass);
  container.addClass(activeClass);
  var curView = responsive.currentView();

  // if on small screens scroll page to top because the height of the lightbox might be larger than the viewport
  if (curView == 'xs' || curView == 'sm') {
    smoothScroll.smoothScrollTo();
  }
});

closeBtn.on('click', closeContainer);
overlay.on('clickoutside', closeContainer);

function closeContainer() {
  lightbox.removeClass(activeClass);
  container.removeClass(activeClass);
}
